import styled, {DefaultTheme, StyledComponentProps} from 'styled-components';
import {ITypography, Typography} from './typography';
import {
  getFontSizeFromTheme,
  getFontWeightFromTheme,
  getLineHeightFromTheme,
} from '../../ui-utils';

export type CaptionProps = StyledComponentProps<
  'p',
  DefaultTheme,
  ITypography,
  'kind' | 'align'
>;

/**
 Used for multiline pieces of content.
 **/
export const Caption = styled.p<ITypography>`
  ${Typography};

  font-size: ${getFontSizeFromTheme('microcopy')};
  font-weight: ${getFontWeightFromTheme('regular')};
  line-height: ${getLineHeightFromTheme('microcopy')};
`;
